import { render, staticRenderFns } from "./AppUpdateAlert.vue?vue&type=template&id=7fdb6aee&scoped=true&"
import script from "./AppUpdateAlert.vue?vue&type=script&lang=ts&"
export * from "./AppUpdateAlert.vue?vue&type=script&lang=ts&"
import style0 from "./AppUpdateAlert.vue?vue&type=style&index=0&id=7fdb6aee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb6aee",
  null
  
)

export default component.exports